import { render, staticRenderFns } from "./CRMOrderDetails.vue?vue&type=template&id=d9ad61f2&"
import script from "./CRMOrderDetails.vue?vue&type=script&lang=js&"
export * from "./CRMOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CRMOrderDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports